import React, {Component, useRef} from 'react'
//redux
import { connect } from "react-redux";
import { getUserInfoData } from "../../common/User/store/actionCreators";
//样式
import {
    Container
} from "./style";

//组件
import { ImageUploader, Space, Toast, Dialog } from 'antd-mobile'
import {FileItem } from 'antd-mobile/es/components/image-uploader'
import $axios from "../../request";




class VodUpload extends Component {
    constructor(props) {
        super(props)
        this.state = {
            vodList:[],
            imgMaxCount:6,
        }
    }

    componentDidMount() {

        if(this.props.vid){
            this.setState({
                vodList: [{
                    url: require("assets/images/uploadSucceed.png")
                }]
            })
        }



    }


    onVodChange=async(vodList)=>{

        console.log("onImgChange",vodList)

       this.setState({vodList:vodList});
       if(vodList.length===0){
           this.props.parent('')
       }else{
           this.props.parent(this.state.vid)
       }
    }
     onUpload=async(file:File)=>{
        console.log("mockUpload",file)

         let response1 = '';
       await $axios.uploadRequest('/vod/upload', file)
            .then((response) => {
                if (response && response.succeed) {
                    response1= response;
                    this.setState({vid:response1.data?.vid});
                    //this.props.parent(response)
                }
            });
         return{
                 url: require("assets/images/uploadSucceed.png"),
               }

    }

     beforeUpload=async(files: File[])=> {
        return files.filter(file => {
            if (file.size > 1024 * 1024*500) {
                Toast.show('请选择小于 500M 的视频')
                return false
            }
            if(!file.type.includes('mp4')){
                Toast.show(`只允许上传视频`);
                return false;
            }
            return true
        })
    }




    render() {
        let { vodList,imgMaxCount } = this.state
        let { userInfo} = this.props;

        return (
            <Container>
                <div className="container">
                    <ImageUploader
                        value={vodList}
                        onChange={this.onVodChange}
                        upload={this.onUpload}
                        accept={'video/*'}
                        multiple
                        deletable
                        maxCount={1}
                        showUpload={vodList.length < imgMaxCount}
                        beforeUpload={this.beforeUpload}
                        onCountExceed={exceed => {
                            Toast.show(`最多选择 ${imgMaxCount} 张图片，你多选了 ${exceed} 张`)
                        }}
                        onDelete={() => {
                            return Dialog.confirm({
                                content: '是否确认删除',
                            })
                        }}
                    />
                </div>


            </Container>
        )
    }
}

const mapState = state => {

    return {
        userInfo:state.getIn(['user', 'userInfo'])
    }

}
const mapDispatch = dispatch => {
    return {

        _getUserInfoData(data) {

            dispatch(getUserInfoData(data))
        }
    }
}

export default connect(mapState, mapDispatch)(VodUpload)
